import './App.css';

// Router 
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

//Pages
import Home from './pages/Home';
import Onboarding from './pages/Onboarding';
import Onboardingv2 from './v2/Onboardingv2';
import Terms from './pages/Legal/Terms';
import Pipeline from './pages/Pipeline/Pipeline';
import SimpleEntry from './pages/SimpleEntry/SimpleEntry';

//Promo
import Promo from './pages/Promo/Promo';
import Info from './pages/Promo/Info/Info';

//Authorization
import PrivateRoutes from './components/privateroutes/PrivateRoutes';
import SignIn from "./pages/Auth/SignIn";
import ForgotPassword from './pages/Auth/ForgotPassword';

//Clients
import MaxOutPayments from './pages/Partners/MaxOutPayments/Form'
import StoneSpot from './pages/Partners/StoneSpot/Form'

//Client Logos
import StoneSpotLogo from '../src/img/StoneSpot/StoneSpot.png'
import MaxOutLogo from '../src/img/MaxOutPayments/Maxout.png'

//Other Logos
import CoastalLogo from '../src/img/Coastal/CoastalLogo.png'


//Core
import Nav from './components/Nav'

// Authentication
import { AuthProvider } from './context/AuthContext'


function App() {
  return (
    <>
      <AuthProvider>

        <Router basename={"/"}>
          {/* <Nav /> */}
          <Routes>
            {/* <Route
              path="/"
              element={<Home />}
            />

            <Route
              path="/onboarding"
              element={<Onboarding />}
            /> */}

            <Route
              path="/"
              element={<Onboarding />}
            />

            <Route
              path="/info"
              element={<Info />}
            />

            <Route
              path="/promo"
              element={<Promo promo='true' />}
            />

            <Route
              path="/sign-in"
              element={<SignIn />}
            />

            <Route
              path="/forgot-password"
              element={<ForgotPassword />}
            />

            <Route element={<PrivateRoutes />}>
              <Route path="/pipeline" element={<Pipeline />} />
              <Route path="/simple-entry" element={<SimpleEntry />} />
            </Route>

            {/*Clients*/}
            <Route
              path="/MaxOutPayments"
              element={<Onboardingv2 landing={true} partner={"maxout"}
                homeContainer={"Maxout-container"} container={"App-container"} landingColor="#0078ba"
                logo={MaxOutLogo} />}
            />

            <Route
              path="/StoneSpot"
              element={<Onboardingv2 landing={true} partner={"stonespot"}
                homeContainer={"StoneSpot-container"} container={"Coastal-container"}
                logo={StoneSpotLogo} formLogo={[CoastalLogo, 'h-32']} landingColor="#da1f26" color="#22a9e1" disclamer={true}
                disclamerTxt={"StoneSpot payments is powered by Coastal Acquiring Secure Holdings. To proceed with your application and set up payment acceptance, please click \"Continue\" below. This will redirect you to our secure application page where you can safely enter your information."}
                disclamerTitle={"Notice"} />}
            />

            <Route
              path="/terms"
              element={<Terms
                container={"Coastal-container"}
              />}

            />

          </Routes>
        </Router>
      </AuthProvider>
    </>
  );
}

export default App;
